export const DEFUNTO_ANNUAL_STATS_QUERY = `
  query DefuntoAnnualStats($orgId: ID!, $dateRef: String!) {
    defunto_period_stats(
      first: 1000,
      where: {
        org_pointer: { have: { objectId: { equalTo: $orgId } } }
        period_type: { equalTo: "billing" }
        date_ref: { equalTo: $dateRef }
      },
      order: [period_start_ASC]
    ) {
      edges {
        node {
          period_key
          period_start
          period_end
          last_computed_at
          total_count
          purchased_amount
          limit_is_flat
          pct_used
          pct_projected
          expected_total
          prediction_available
          prediction_elapsed_days
          prediction_total_days
          expected_excess_on
          needs_more_data
          usage_state
        }
      }
    }
  }
`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default DEFUNTO_ANNUAL_STATS_QUERY;
